import { Button } from './Button';
import { createSprite } from '../../../utils/GameEngine';

export class SettingsButtonSquare extends Button {
  private cog: PIXI.Sprite;

  constructor(callback?: () => any) {
    super('blue_button_square', callback, null, true, true, 1);
  }

  protected drawLayout(): void {
    super.drawLayout();
    this.cog = createSprite('cog', this);
    this.cog.position.set((this.width - this.cog.width) / 2, (this.height - this.cog.height) / 2 - 2);
  }
}